<template>
  <base-modal-component>
    <template v-slot:header>
      <h4 class="u-typography-color md-title">
        Meta Tags Item
      </h4>
    </template>

    <template v-slot:body>
      <p
        v-if="error && error.messages"
        class="md-error"
      >
        {{ error.messages }}
      </p>
      <form
        novalidate
      >
        <div class="c-config-input-type">
          <md-field :class="getValidationClass($v.scriptItem.name)">
            <label for="name">Name</label>
            <md-input
              v-model="scriptItem.name"
              v-focus
              required
              name="name"
              type="text"
              class="md-input"
              autocomplete="off"
            />
            <span
              v-if="!$v.scriptItem.name.required"
              class="md-error"
            >Name is required</span>
          </md-field>
          <error-response-messages :field-name="'name'" />
        </div>
        <div class="c-config-input-type u-flex-direction-column">
          <md-switch
            v-model="showPageOptions"
            class="c-show-page-options"
            @change="switchPageOptions()"
          >
            For specific page
          </md-switch>
          <md-field v-if="showPageOptions">
            <md-select id="pageOptions" v-model="scriptItem.pageName" name="pageOptions">
              <md-option
                v-for="page in customPages"
                :key="page.id"
                :value="page.name"
              >
                {{ page.name }}
              </md-option>
            </md-select>
            <label for="pageOptions">Page</label>
          </md-field>
        </div>
        <div class="c-config-input-type">
          <md-field :class="getValidationClass($v.scriptItem.script)">
            <label for="script">Meta tag</label>
            <md-textarea
              v-model="scriptItem.script"
              required
              name="script"
              type="text"
              class="c-config-textarea"
              autocomplete="off"
            />
            <span
              v-if="!$v.scriptItem.script.required"
              class="md-error"
            >Script is required</span>
          </md-field>
          <error-response-messages :field-name="'script'" />
        </div>
      </form>
    </template>
    <template v-slot:footer>
      <div class="u-mr-xs">
        <generic-button
          variation="grey"
          @click="close"
        >
          Close
        </generic-button>
      </div>
      <generic-button
        variation="red"
        @click="validateForm"
      >
        Continue
      </generic-button>
    </template>
  </base-modal-component>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";

import GenericButton from '@/shared/buttons/GenericButton'
import ErrorResponseMessages from '@/shared/error-response-messages/ErrorResponseMessages'
import BaseModalComponent from '@/shared/modal/BaseModalComponent'
import { validationBaseMixin } from '@/mixins/ValidationBaseMixin'

export default {
  name: 'MetaTagItemModal',
  components: {
    GenericButton,
    ErrorResponseMessages,
    BaseModalComponent
  },
  mixins: [validationBaseMixin],
  props: {
    scriptItem: {
      type: Object,
      required: true,
    },
    successFunction: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      messages: {
        error: null,
        success: null,
      },
      showPageOptions: false,
    };
  },
  computed: {
    ...mapGetters("response", ["success", "error"]),
    ...mapGetters('customPages', ['customPages']),
  },

  validations: {
    scriptItem: {
      name: {
        required
      },
      script: {
        required
      },
    },
  },

  created() {
    this.showPageOptions = !!this.scriptItem.pageName;
  },

  methods: {
    ...mapActions("response", ["handleSuccess", "handleError", "resetError"]),

    validateForm () {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.successFunction(this.scriptItem);
        this.close();
      }
    },

    close() {
      this.$emit("close");
    },

    switchPageOptions() {
      if (!this.showPageOptions) {
        this.scriptItem.pageName = null;
      } else {
        this.scriptItem.pageName = this.customPages.length > 0 ? this.customPages[0].name : null;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
// script/markup editor: monospace, fixed height (as before), scrolls inside
.c-config-textarea {
  width: 100%;
  height: 220px !important;
  min-height: 220px;
  max-height: none;
  resize: none !important;
  font-family: 'SFMono-Regular', Menlo, Consolas, monospace;
  font-size: 13px;
  line-height: 1.5;
}

</style>
